import React from 'react';
import { FDTableCell, FDTableRow } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { metaOverrideSet } from './metaOverrideSet';

const PlannerTransitionTableRow = ({
  fields,
  resource,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  const loadDetailsModal = async () => {
    await loadModalCollectionByLink(resource.relationship(fr.relationships.details.name).link('related').url());
  };

  const handleClick = resource.withRelationship(
    fr.relationships.details.name,
    () => loadDetailsModal,
    () => null,
  );

  return (
    <FDTableRow
      hover
      onClick={async () => handleClick()}
      key={resource.id()}
    >
      {fields.map(field => {
        return (
          <FDTableCell key={field.attr('name')}>
            <MetaControl
              resource={resource}
              attrName={field.attr('name')}
              metaOverrideSet={metaOverrideSet}
            />
          </FDTableCell>);
      })}
    </FDTableRow>
  );
};

PlannerTransitionTableRow.defaultProps = {};

PlannerTransitionTableRow.propTypes = {
  fields: PropTypes.array.isRequired,
  resource: PropTypes.object.isRequired,
};

export default PlannerTransitionTableRow;
